import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationIT from './locales/it/translation.json';
import translationDE from './locales/de/translation.json';
import translationFR from './locales/fr/translation.json';

const languages = [
  { code: 'en', translation: translationEN },
  { code: 'it', translation: translationIT },
  { code: 'de', translation: translationDE },
  { code: 'fr', translation: translationFR },
];

const resources = languages.reduce((acc, lang) => {
  acc[lang.code] = { translation: lang.translation };
  return acc;
}, {} as Record<string, { translation: typeof translationEN }>);

// Retrieves the system language
const getSystemLanguage = (): string => {
  const systemLang = navigator.language.split('-')[0]; // Extracts 'it' from 'it-IT'
  const supportedLanguages = Object.keys(resources);

  // Retrieves from localstorage or if system language is supported, uses it, otherwise uses English
  const fromDevice = localStorage.getItem('locale');

  const res = fromDevice ? fromDevice : supportedLanguages.includes(systemLang) ? systemLang : 'en';

  return res;
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSystemLanguage(), // Use system language
    fallbackLng: 'en', // Fallback language if translation is not available
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
